/* istanbul ignore next */
const ACTIONS = {
    DISCONTINUED_BRAND_DISMISS_ALERT_BOX: 'DISCONTINUED_BRAND_DISMISS_ALERT_BOX'
};
/* istanbul ignore next */
const ACTION_CREATORS = {
    discontinuedBrandDismissAlertBox() {
        return {
            type: ACTIONS.DISCONTINUED_BRAND_DISMISS_ALERT_BOX
        };
    }
};
export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
